function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TopologyValidationError = /*#__PURE__*/function () {
  function TopologyValidationError() {
    _classCallCheck(this, TopologyValidationError);
    TopologyValidationError.constructor_.apply(this, arguments);
  }
  return _createClass(TopologyValidationError, [{
    key: "getErrorType",
    value: function getErrorType() {
      return this._errorType;
    }
  }, {
    key: "getMessage",
    value: function getMessage() {
      return TopologyValidationError.errMsg[this._errorType];
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      return this._pt;
    }
  }, {
    key: "toString",
    value: function toString() {
      var locStr = '';
      if (this._pt !== null) locStr = ' at or near point ' + this._pt;
      return this.getMessage() + locStr;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return TopologyValidationError;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { TopologyValidationError as default };
TopologyValidationError.constructor_ = function () {
  this._errorType = null;
  this._pt = null;
  if (arguments.length === 1) {
    var errorType = arguments[0];
    TopologyValidationError.constructor_.call(this, errorType, null);
  } else if (arguments.length === 2) {
    var _errorType = arguments[0];
    var pt = arguments[1];
    this._errorType = _errorType;
    if (pt !== null) this._pt = pt.copy();
  }
};
TopologyValidationError.ERROR = 0;
TopologyValidationError.REPEATED_POINT = 1;
TopologyValidationError.HOLE_OUTSIDE_SHELL = 2;
TopologyValidationError.NESTED_HOLES = 3;
TopologyValidationError.DISCONNECTED_INTERIOR = 4;
TopologyValidationError.SELF_INTERSECTION = 5;
TopologyValidationError.RING_SELF_INTERSECTION = 6;
TopologyValidationError.NESTED_SHELLS = 7;
TopologyValidationError.DUPLICATE_RINGS = 8;
TopologyValidationError.TOO_FEW_POINTS = 9;
TopologyValidationError.INVALID_COORDINATE = 10;
TopologyValidationError.RING_NOT_CLOSED = 11;
TopologyValidationError.errMsg = ['Topology Validation Error', 'Repeated Point', 'Hole lies outside shell', 'Holes are nested', 'Interior is disconnected', 'Self-intersection', 'Ring Self-intersection', 'Nested shells', 'Duplicate Rings', 'Too few distinct points in geometry component', 'Invalid Coordinate', 'Ring is not closed'];